/* eslint-disable lines-between-class-members */
/* global define */
/**
 * Temporary ui_migration module used to map URLs from the old Cloud UI to Phoenix routes.  The intent
 * is that this module will be deprecated once the Phoenix app has taken over all the capabilities
 * of the old UI.
 *
 * Copyright 2014 LightSpeed Retail. All rights reserved.
 * Created by kbergeron
 */

// define the Ashes namespace
//
// Private declarations
//

/**
 * All defined route mappings from the old UI to Phoenix.  This structure takes the form:
 *
 * [form_name] : {
 *      [name] : [Phoenix route],
 *      [name] : [Phoenix route],
 *      ...
 * }
 */
const _routeMappings = {
  'listing.refresh': {
    'admin.listings.custom_fields': 'settings/advanced/customfields',
  },

  ui_tab: {
    inventory: 'inventory',
  },

  default_route: {},
};

/**
 * Abstract class for a mapped route.  A route in this context is defined as the the URL path that may map to a Marionette
 * route.
 *
 * @param route Contains the routing information from the old UI
 * @param urlParams A hash containing the parameters to be sent with the request
 *
 * @constructor
 */
abstract class Route implements AshesRoute {
  route: AshesRoute['route'];
  urlParams: AshesRoute['urlParams'];
  // @ts-expect-error ts-migrate(2564) FIXME: Property '_formName' has no initializer and is not... Remove this comment to see the full error message
  _formName: AshesRoute['_formName'];
  // @ts-expect-error ts-migrate(2564) FIXME: Property '_viewName' has no initializer and is not... Remove this comment to see the full error message
  _viewName: AshesRoute['_viewName'];

  constructor(route: string | ContentMap, urlParams: AshesRoute['urlParams']) {
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'undefined' is not assignable to type 'string... Remove this comment to see the full error message
    this.route = undefined;
    this.urlParams = urlParams || {};

    if (route) {
      this.init(route);
    }
  }

  /**
   * Performs the basic initialization of an Route class.  The functions initViewName and
   * initFormName are expected to be implemented by a more specific route class.
   *
   * @param route Contains the routing information from the old UI
   */
  init: AshesRoute['init'] = route => {
    this.initViewName(route);
    this.initFormName(route);
    this.initRoute();
  };

  /**
   * Initializes the route property of the Route object.  This will perform a lookup into the
   * _routeMappings object.
   */
  initRoute: AshesRoute['initRoute'] = () => {
    if (this._formName && this._viewName) {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (_routeMappings[this._formName] && _routeMappings[this._formName][this._viewName]) {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        this.route = `/client/index.html#${_routeMappings[this._formName][this._viewName]}`;

        // @ts-expect-error wrong types for underscore
        const params = _.pairs(this.urlParams);
        if (params.length) {
          this.route += '?';
          _.each(
            params,
            (param, index) => {
              // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
              this.route += `${param[0]}=${encodeURIComponent(param[1])}`;
              if (index !== params.length - 1) {
                this.route += '&';
              }
            },
            // @ts-expect-error wrong types for underscore
            this
          );
        }
      }
    }
  };

  initViewName = (..._args: any[]) => {};
  initFormName = (..._args: any[]) => {};
}

/**
 * Concrete class to define a route for an "old UI" AJAX request.  This type of request identifies the view to load
 * using a combination of 'form_name' and 'name' attributes defined in an object that would eventually be composed into
 * form data.  We use this data as indexes to map to a route in the AshesRouteMappings object.
 *
 * @param urlParams A hash containing the parameters to be sent with the request
 */
class AjaxRoute extends Route {
  /**
   * Determines the view name from information contained within the specified route.
   *
   * @param route An object defining the form data to include in the AJAX call
   */
  // @ts-expect-error ts-migrate(2502) FIXME: 'initViewName' is referenced directly or indirectl... Remove this comment to see the full error message
  initViewName: AjaxRoute['initViewName'] = (route: ContentMap) => {
    if (route.name) {
      this._viewName = route.name;
    } else {
      let jsonData = {} as AjaxListing;

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'ajax_listing' does not exist on type 'Co... Remove this comment to see the full error message
      if (route.ajax_listing) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'ajax_listing' does not exist on type 'Co... Remove this comment to see the full error message
        jsonData = JSON.parse(route.ajax_listing);
      } else if (route.ajax_view) {
        jsonData = JSON.parse(route.ajax_view);
      }
      if (jsonData.name) {
        this._viewName = jsonData.name;
      }
    }

    if (!this._viewName) {
      // eslint-disable-next-line no-throw-literal
      throw `The required attribute 'name' is not defined in the specified route${route}`;
    }
  };

  /**
   * Determines the form name from information contained within the specified route.
   *
   * @param route An object defining the form data to include in the AJAX call
   */
  // @ts-expect-error ts-migrate(2502) FIXME: 'initFormName' is referenced directly or indirectl... Remove this comment to see the full error message
  initFormName: AjaxRoute['initFormName'] = (route: ContentMap) => {
    if (route.form_name) {
      this._formName = route.form_name;
    } else {
      // eslint-disable-next-line no-throw-literal
      throw `The required attribute 'form_name' is not defined in the specified route : ${route}`;
    }
  };
}

class UrlRoute extends Route {
  /**
   * Determines the view name from information contained within the specified route.
   *
   * @param url A string containing an "old UI" fully-qualified or relative URL
   */
  // @ts-expect-error ts-migrate(2502) FIXME: 'initViewName' is referenced directly or indirectl... Remove this comment to see the full error message
  initViewName: UrlRoute['initViewName'] = (url: string) => {
    const theUrl = this.getURL(url);
    const formName = this.getURLParameter(theUrl.search, 'form_name');
    const splitPath = theUrl.pathname.split('/');

    if (splitPath.length < 2 || splitPath[1].length) {
      // a pathname has been specified (e.g. register.php)
      if (formName !== null) {
        this._viewName = formName;
      }
    } else {
      // TODO : Extraction of the view-name for 'root-level' URLs; this is view-specific (an example follows)
      switch (formName) {
        case 'ui_tab':
          const viewName = this.getURLParameter(theUrl.search, 'tab');
          switch (viewName) {
            case 'inventory':
              this._viewName = viewName;
              break;

            default:
              break;
          }
          break;

        default:
          break;
      }
    }
  };

  /**
   * Determines the form name from information contained within the specified route.
   *
   *  @param url A string containing an "old UI" fully-qualified or relative URL
   */
  // @ts-expect-error ts-migrate(2502) FIXME: 'initFormName' is referenced directly or indirectl... Remove this comment to see the full error message
  initFormName: UrlRoute['initFormName'] = (url: string) => {
    const theUrl = this.getURL(url);
    const splitPath = theUrl.pathname.split('/');

    if (splitPath.length < 2 || splitPath[1].length) {
      this._formName = splitPath[splitPath.length - 1];
    } else {
      this._formName = this.getURLParameter(theUrl.search, 'form_name');
    }
  };

  /**
   * Retrieves a parameter from a URL.
   *
   *  @param url      A string containing an "old UI" fully-qualified or relative URL
   *  @param param    The parameter to retrieve
   *  @returns        The parameter value or null if not found
   */
  // @ts-expect-error ts-migrate(2502) FIXME: 'getURLParameter' is referenced directly or indire... Remove this comment to see the full error message
  getURLParameter: UrlRoute['getURLParameter'] = (url: string, param: string) => {
    const parameterSearch = new RegExp(`[?|&]${param}=([^&;]+?)(&|#|;|$)`);

    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
    // eslint-disable-next-line no-sparse-arrays
    return decodeURIComponent((parameterSearch.exec(url) || [, ''])[1]) || null;
  };

  /**
   * Construct an anchor element from a URL.  This function takes advantage of the fact that we can use an
   * anchor element's Location properties to decompose the link.
   *
   *  @param url      A string containing an "old UI" fully-qualified or relative URL
   *  @returns        An anchor element constructed from the specified URL.
   */
  // @ts-expect-error ts-migrate(2502) FIXME: 'getURL' is referenced directly or indirectly in i... Remove this comment to see the full error message
  getURL: UrlRoute['getURL'] = (url: string) => {
    const theURL = document.createElement('a');
    theURL.href = url;

    return theURL;
  };
}

/**
 * Concrete class to define a route for an "old UI", JavaScript initiated, browser request.  This type of request
 * would be invoked using the merchantos.utils.openUrl function.  The string passed in can be both a fully-qualified
 * or relative URL.  Most requests of this type are related to calls made into register.php but we will likely use
 * this class when mapping to Marionette routes from back-end redirects when we replace calls that request views
 * through HTML links.
 *
 * @param route A string containg the "old UI" URL
 * @param urlParams A hash containing the parameters to be sent with the request
 */

window.Ashes = {
  /**
   *  Construct a route object based on the type of the object.
   *
   * @param route         Either an object (for an AJAX request) or a string (for a URL).
   * @returns {Object}    The object returned depends on the type of request (either an AjaxRoute or an
   *                      UrlRoute.
   */
  // @ts-expect-error ts-migrate(2322) FIXME: Type '<T extends unknown>(route: T) => AjaxRoute |... Remove this comment to see the full error message
  createRoute(route) {
    const phoenixUrlParams = {};

    try {
      if (typeof route === 'string') {
        return new UrlRoute(route, phoenixUrlParams);
      }
      if (route instanceof Object && !(route instanceof Array)) {
        // @ts-expect-error ts-migrate(2352) FIXME: Conversion of type 'T & Object' to type 'ContentMa... Remove this comment to see the full error message
        return new AjaxRoute(route as ContentMap, phoenixUrlParams);
      }
    } catch (e) {
      // do nothing
    }

    return null;
  },

  /**
   *  Determine if the specified url is a Phoenix URL route.  Right now this check is pretty basic but should be
   *  sufficient.  A more specific check would be to verify that the URL maps to an actual route.
   *
   * @param url           A string containing a fully-qualified or relative URL.
   * @returns {boolean}   true if the route is a Phoenix route or false otherwise.
   */
  isPhoenixRoute(url) {
    return url.indexOf('index.html#') !== -1;
  },
};
